// Rendering parameters
export const FRAME_RATE = 20;

export enum AbortReason {
    Close = 'close',
}

export const PLAY_VIDEO_TIMEOUT = 6000;
